import { localizationConst as localization } from "./localizationConst"
import {
  CheckOutlined,
  WarningOutlined,
  CloseCircleOutlined,
  InfoOutlined,
  BugOutlined,
} from "@ant-design/icons"
import translations from '../translation.json'
import { notification } from "antd"
import {
  MASTER_DATA_PAGE_PERMISSION,
  hasContractInquiryFunctionalAccess,
  hasGrantedPermissionWithPrefix,
} from "./permissionGrant"
declare let abp: any

export type TranslationType = {
  en: {
    [key: string]: string | Record<string, string>;
  };
  vi: {
    [key: string]: string | Record<string, string>;
  };
};


export function L(key: string, ...args: any[]): string {
  let localizedText = abp.localization.localize(
    key,
    localization.defaultLocalizationSourceName,
  )
  const translationsTyped = translations as TranslationType

  if (!localizedText || localizedText === key) {
    //fallback to translations file
    try {
      localizedText =
        translationsTyped[abp.localization.currentCulture.name][
          localization.defaultLocalizationSourceName
        ][key]

      if (!localizedText) {
        throw new Error(`Translation not found for key: ${key}`)
      }
    } catch (error) {
      localizedText = key
    }
  }

  if (!args || !args.length) {
    return localizedText
  }

  return abp.utils.formatString(localizedText, ...args)
}

export function LError(key: string, ...args: any[]): string {
  let localizedText = abp.localization.localize(
    key,
    localization.sourceWebError
  )
  if (!localizedText) {
    localizedText = key
  }

  if (!args || !args.length) {
    return localizedText
  }

  return abp.utils.formatString(localizedText, ...args)
}

export function LNotification(key: string, ...args: any[]): string {
  let localizedText = abp.localization.localize(
    key,
    localization.sourceWebNotification
  )
  if (!localizedText) {
    localizedText = key
  }

  if (!args || !args.length) {
    return localizedText
  }

  return abp.utils.formatString(localizedText, ...args)
}

export function LCategory(key: string, ...args: any[]): string {
  let localizedText = abp.localization.localize(
    key,
    localization.sourceWebCategory
  )
  if (!localizedText) {
    localizedText = key
  }

  if (!args || !args.length) {
    return localizedText
  }

  return abp.utils.formatString(localizedText, ...args)
}

export function LMainMenu(key: string, ...args: any[]): string {
  let localizedText = abp.localization.localize(
    key,
    localization.sourceWebMainMenu
  )
  const translationsTyped = translations as TranslationType

  if (!localizedText || localizedText === key) {
    try {
      localizedText =
        translationsTyped[abp.localization.currentCulture.name]?.[
          localization.sourceWebMainMenu
        ]?.[key]

      if (!localizedText) {
        localizedText = key
      }
    } catch {
      localizedText = key
    }
  }

  if (!args || !args.length) {
    return localizedText
  }

  return abp.utils.formatString(localizedText, ...args)
}

export function isGranted(permissionName: string): boolean {
  if (!permissionName || permissionName === "") {
    return true
  }
  if (abp.auth.isGranted(permissionName)) {
    return true
  }
  // Master Data page gate is hidden from role/bundle UI (parent = PagesAdministration).
  if (permissionName === MASTER_DATA_PAGE_PERMISSION) {
    return hasGrantedPermissionWithPrefix(
      abp.auth?.grantedPermissions,
      MASTER_DATA_PAGE_PERMISSION
    )
  }
  return false
}

export function isGrantedAny(...args: string[]): boolean {
  for (let i = 0; i < args.length; i++) {
    if (isGranted(args[i])) {
      return true
    }
  }
  return false
}

/** Sổ thu chi module access — excludes data-only PaymentTerm* permissions. */
export function hasIncomeModuleAccess(): boolean {
  return hasContractInquiryFunctionalAccess(abp.auth?.grantedPermissions)
}

export function getNotificationIconBySeverity(severity) {
  switch (severity) {
    case abp.notifications.severity.SUCCESS:
      return CheckOutlined
    case abp.notifications.severity.WARN:
      return WarningOutlined
    case abp.notifications.severity.ERROR:
      return CloseCircleOutlined
    case abp.notifications.severity.FATAL:
      return BugOutlined
    case abp.notifications.severity.INFO:
    default:
      return InfoOutlined
  }
}

abp.notify.success = (description, message?, options?) => {
  notification.success({
    message: message || L("NOTIFICATION"),
    description: description,
    onClick: () => {
      options?.onClick()
    },
  })
}
abp.notify.info = (description, message?, options?) => {
  notification.info({
    message: message || L("NOTIFICATION"),
    description: description,
    onClick: () => {
      options?.onClick()
    },
  })
}

abp.notify.error = (description, message?, options?) => {
  notification.error({
    message: message || L("NOTIFICATION"),
    description: description,
    onClick: () => {
      options?.onClick()
    },
  })
}
